import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    withdrawalAmount: 'Withdrawal amount',
    initiated: 'Initiated',
  },
};
